import { useTranslation } from 'react-i18next'

import { Button, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const AddConditionButtons = ({ onAddCondition, disabled, conditionTypeOptions }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleS">{t('Añadir condición')}</Text>
      <Styles.ButtonsRow>
        {conditionTypeOptions.map(option => (
          <Button
            key={option.value}
            variant="outlined"
            size="s"
            onClick={() => onAddCondition(option.value)}
            disabled={disabled}
          >
            <Styles.ButtonContent>
              <option.icon size={16} />
              {t(option.label)}
            </Styles.ButtonContent>
          </Button>
        ))}
      </Styles.ButtonsRow>
    </Styles.Container>
  )
}

export default AddConditionButtons
